import FocusTrap from 'focus-trap-react';

import PropTypes from 'prop-types';

import React from 'react';
import classnames from 'classnames';
import TocMenu from './toc_menu.jsx';

const ReaderTOCButton = React.forwardRef((props, ref) => {
    const classes = classnames('icon', 'cl-icon', 'cl-icon-list');
    return (
        <button
            className={classes}
            onClick={props.clickHandler}
            onKeyDown={props.keyPressHandler}
            onKeyUp={props.keyPressHandler}
            ref={ref}
        >
            <span className="aural">table of contents</span>
        </button>
    );
});

ReaderTOCButton.displayName = 'ReaderTOCButton';
ReaderTOCButton.propTypes = {
    clickHandler: PropTypes.func,
    keyPressHandler: PropTypes.func,
};

class ReaderTOCPanel extends React.Component {
    static propTypes = {
        children: PropTypes.object.isRequired,
        open: PropTypes.bool,
        closeMenu: PropTypes.func.isRequired,
    };

    render() {
        const classes = classnames('dropdown-menu');

        // I know how much you love inline styles, so I copied these directly
        // from react-aria-modal. Actually, we already know that code works in
        // Engage, so there's no reason to make this complicated.
        // https://github.com/davidtheclark/react-aria-modal/blob/ccd32947b35efbb4a48e138c5e9a7a0cd1c4c2e8/lib/Modal.js#L65-L76
        const underlayStyle = {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1050,
            overflowX: 'hidden',
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            textAlign: 'center',
        };

        if (this.props.open) {
            return (
                <FocusTrap
                    focusTrapOptions={{ onDeactivate: this.props.closeMenu }}
                >
                    <div
                        onClick={this.props.closeMenu}
                        className="underlay"
                        style={underlayStyle}
                    />
                    <ul
                        style={{ display: 'block', zIndex: 1060 }}
                        className={classes}
                    >
                        {React.Children.map(this.props.children, Child => (
                            <li>{Child}</li>
                        ))}
                    </ul>
                </FocusTrap>
            );
        }
        return null;
    }
}

class ReaderTOCMenu extends React.Component {
    static propTypes = {
        chapters: PropTypes.array,
        content: PropTypes.any.isRequired,
    };

    state = {
        open: false,
    };

    tocButton = React.createRef();

    componentDidUpdate(prevProps, prevState) {
        if (prevState.open === true && this.state.open === false) {
            this.tocButton.current.focus();
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('disable-scroll');
    }

    tocButtonRef = el => {
        this.tocButton = el;
    };

    onEscape = e => {
        if (e.key === 'Escape') {
            this.closeMenu();
        }
    };

    closeMenu = () => {
        this.setState({ open: false });
        this.toggleTocOpenClass(this.state.open);
    };

    handleDropdownButtonClicked = () => {
        this.setState({ open: !this.state.open });
        this.toggleTocOpenClass(!this.state.open);
    };

    handleDropdownButtonKeyPress = e => {
        switch (e.key) {
            case [' ', 'Enter']:
                this.setState({ open: !this.state.open });
                break;
        }
    };

    toggleTocOpenClass = isOpen => {
        document.body.classList.toggle('disable-scroll', isOpen);
    };

    render() {
        const { content } = this.props;
        const dropdownClasses = classnames('dropdown-wrapper', 'dropdown-toc');

        return (
            <span className={dropdownClasses} onKeyDown={this.onEscape}>
                <ReaderTOCButton
                    ref={this.tocButton}
                    keyPressHandler={this.handleDropdownButtonKeyPress}
                    clickHandler={this.handleDropdownButtonClicked}
                />
                <ReaderTOCPanel
                    open={this.state.open}
                    closeMenu={this.closeMenu}
                >
                    <TocMenu
                        content={content}
                        open={this.state.open}
                        closeMenu={this.closeMenu}
                        chapters={this.props.chapters}
                    />
                </ReaderTOCPanel>
            </span>
        );
    }
}

export default ReaderTOCMenu;



// WEBPACK FOOTER //
// ./src/components/engage_reader/navbar/toc.jsx